module.exports = __webpack_public_path__ + "static/media/icon-key.7c654223.svg";